<input [readonly]="options.readonly" [formControl]="control" placeholder="{{options.placeholder}}" type="text">